import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Partners } from '../interfaces/partners';
import { ConfigurationSelectionDTO } from 'src/app/modules/common-requests/edit-contract/dto/response-dto/configuration-selection-response-dto';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PartnerDataService {
    private dataSource: BehaviorSubject<object> = new BehaviorSubject<object>({});
    public data: Observable<Partners> = this.dataSource.asObservable();

    public constructor(private _http: HttpClient) { }

    public sendData(data: Partners | null) : void {
        this.dataSource.next(data!);
    }

    public getConfigurationSelectionContract(): Observable<ConfigurationSelectionDTO> {
        return this._http.get<ConfigurationSelectionDTO>(environment.baseUrl + 'Configuration/selection/contract?isNew=false');
    }
}
